import { getUserId, getMerchantId } from './user.service';
import { Api } from 'src/common';

type AccountSummary = {
  transactionDebitAmount: number;
  transactionCreditAmount: number;
};

type AccountTransactions = {
  transactionAmount: string;
  transactionDescription: string;
  processingDate: string;
};

export interface IBCADashboard {
  accountTransactions: AccountTransactions[];
  accountSummary: AccountSummary[];
}

type BCADashboardResponse = {
  ok: boolean;
  result: IBCADashboard;
  message?: string;
};

export async function getBCADashboardData(
  abortController: AbortController,
): Promise<BCADashboardResponse> {
  const userId = getUserId();
  const merchantId = getMerchantId();
  const endpoint = `bca/dashboard?userReference=${userId}&merchantId=${merchantId}`;

  const result = await Api.get<BCADashboardResponse>(endpoint, {
    signal: abortController?.signal || null,
  });

  if (result && result?.response && result.status === 200) {
    return {
      ok: true,
      result: result.response.result,
    };
  }

  if (result.status > 300 && result.status < 500) {
    return {
      ok: false,
      result: result.response.result,
      message:
        "Uh oh! We're experiencing technical difficulties, but we're working on it. Please try again later.",
    };
  }

  throw new Error(
    `Get BCA Dashboard: Invalid response: ${result.status}: ${JSON.stringify(result.response)}`,
  );
}
